import { Injectable } from '@angular/core';
import { SessionStorage } from '../../core/services/global/storage/session-storage.service';
import { isNullOrUndefined } from 'util';

@Injectable()
export class RequestStorageService {

  readonly REQUESTS = 'REQUESTS';

  constructor(private sessionStorage: SessionStorage) {
  }

  putRequest(serviceKey: string, request: CacheRequestModel): void {
    this.sessionStorage.put(this.REQUESTS, this.createRequest(serviceKey, request));
  }

  /**
   * Method returned request
   * @param {string} serviceKey
   * @param {string} uri
   * @returns {Promise<any>}
   */
  getRequest(serviceKey: string, uri: string): Promise<any> {
    let requests = this.getRequests();
    let request: [CacheRequestModel];
    if (!isNullOrUndefined(requests)) {
      let cacheService = requests[serviceKey];

      if (!isNullOrUndefined(cacheService)) {
        request = cacheService.filter((req: CacheRequestModel) => req.url === uri);
      }
    }

    if (!isNullOrUndefined(request) && request.length > 0) {
      return Promise.resolve(request[0].resp);
    }
  }

  /**
   * Method checking request in storage
   * @param {string} serviceKey
   * @param {string} url
   * @returns {boolean}
   */
  isRequest(serviceKey: string, url: string): boolean {
    let requests = this.getRequests();
    if (!isNullOrUndefined(requests)) {
      let cacheService = requests[serviceKey];

      if (!isNullOrUndefined(cacheService)) {
        let filter: [CacheRequestModel] = cacheService.filter((req: CacheRequestModel) => req.url === url);
        if (filter.length > 0) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }

  /**
   * Method removed all requests from provide serviceKey
   * @param {string} serviceKey
   */
  removeCacheService(serviceKey: string): void {
    let requests = this.getRequests();

    if (!isNullOrUndefined(requests) && !isNullOrUndefined(requests[serviceKey])) {
      delete requests[serviceKey];
    }
    this.sessionStorage.put(this.REQUESTS, requests);
  }

  /**
   * Method removed cached requests saved unde
   * @param {string} serviceKey
   * @param {string} url
   */
  removeCacheRequestsFromService(serviceKey: string, url: string): void {
    let requests = this.getRequests();

    if (!isNullOrUndefined(requests)) {
      let cacheService = requests[serviceKey];

      if (!isNullOrUndefined(cacheService)) {
        requests[serviceKey] = cacheService.filter((req: CacheRequestModel) => req.url !== url);
      }
    }

    this.sessionStorage.put(this.REQUESTS, requests);
  }

  /**
   * Method removed everything from storage under 'REQUESTS' key
   */
  removeRequests(): void {
    this.sessionStorage.remove(this.REQUESTS);
  }

  /**
   * Method return all requests saved in storage under 'REQUESTS' key
   * @returns {CacheRequestModel[]}
   */
  getRequests(): CacheRequestModel[] {
    return this.sessionStorage.get(this.REQUESTS);
  }

  private createRequest(serviceKey: string, request: CacheRequestModel): Object {
    let requests: Object = this.getRequests();

    if (isNullOrUndefined(requests)) {
      requests = {};
      requests[serviceKey] = [];
    } else if (!requests.hasOwnProperty(serviceKey)) {
      requests[serviceKey] = [];
    }

    let update: boolean = false;
    requests[serviceKey].forEach((req: CacheRequestModel) => {
      if (req.url === request.url) {
        req.resp = request.resp;
        update = true;
      }
    });

    if (!update) {
      requests[serviceKey].push(request);
    }

    return requests;
  }
}

export class CacheRequestModel {
  url: string;
  resp: any;

  constructor(url: string, resp: any) {
    this.url = url;
    this.resp = resp;
  }
}
